// extracted by mini-css-extract-plugin
export default {"container":"Jobfilter_container__IvKSj","tags":"Jobfilter_tags__Tg6dg","btn":"Jobfilter_btn__K+k7k"};